import React from 'react';

import Routing from './containers/Routing/Routing';
import WidescreenLock from './components/WidescreenLock/WidescreenLock';

function App() {
  return (
    <>
      <Routing />
      <WidescreenLock />
    </>
  );
}

export default App;
